<script setup lang="ts">
  import { computed, watch } from 'vue';
  import { useI18n } from 'vue-i18n';
  import PageContent from '@/components/customerPage/pageContent/PageContent.vue';
  import useIdentityStore from '@/store/identity';
  import { storeToRefs } from 'pinia';
  import useCustomerName from '@/composables/useCustomerName';
  import AdmissionStatus from '@/components/customerPage/AdmissionStatus/AdmissionStatus.vue';
  import UserBroadcastWarning from '@/components/common/UserBroadcastMessage/UserBroadcastWarning.vue';
  import useWindowTitle from '@/composables/useWindowTitle';
  import useAsyncComponentLoader from '@/composables/useAsyncComponentLoader';
  import { useAnnouncer } from '@vue-a11y/announcer';

  defineOptions({ name: 'HomeView' });
  const { t } = useI18n();
  const { polite } = useAnnouncer();
  const { fileNumber } = storeToRefs(useIdentityStore());
  const { fullName } = useCustomerName();
  const { getAsyncComponentWithLoader } = useAsyncComponentLoader();

  const HomeContainer = getAsyncComponentWithLoader(() => import('@/components/customerPage/home/HomeContainer.vue'));

  const title = computed<string>(() => `${t('pages.homepage.title')}, ${fullName.value}`);

  const { setWindowTitle } = useWindowTitle();

  watch(title, () => {
    // Titre générique pour `document.title`, lu par GTM
    setWindowTitle(t('pagesTitle.customerHome'));
    // Titre personnalisé (avec le nom de l'utilisateur) annoncé uniquement au lecteur d'écran.
    polite(`${t('pagesTitle.default')} – ${title.value}`);
  }, { immediate: true });
</script>

<template>
  <PageContent
    :key="fileNumber"
    class="pb-0! text-center"
    narrow-header
  >
    <template #header>
      <p class="mb-2 md:mb-0">
        {{ title }}
      </p>
      <AdmissionStatus class="md:container" />
      <UserBroadcastWarning />
    </template>
    <HomeContainer />
  </PageContent>
</template>
